import React, { memo } from 'react';
import { IconRefresh, IconInfo } from '../../../icons';
import cn from '../../../utils/cn';
import ButtonCTA, {
  ButtonCTASize,
  ButtonCTAVariant,
} from '../../buttons/button-cta/ButtonCTA';

export type ErrorStateCardI18n = {
  message?: React.ReactNode;
  retry?: string;
};

type ErrorStateCardProps = {
  onRetry?: () => void;
  i18n?: ErrorStateCardI18n;
} & Omit<React.ComponentPropsWithoutRef<'div'>, 'children'>;

const ErrorStateCard = ({
  className,
  onRetry,
  i18n = {},
  ...rest
}: ErrorStateCardProps) => {
  const defaultI18n: Required<ErrorStateCardI18n> = {
    retry: 'Réessayer',
    message: (
      <>
        Une erreur est survenue.
        <br />
        Veuillez réessayer.
      </>
    ),
  };

  const finalI18n = { ...defaultI18n, ...i18n };

  return (
    <div
      className={cn(
        'flex size-full flex-col items-center justify-center gap-6 rounded-2xl border-2 border-neutral-300 bg-neutral-100 p-6',
        className,
      )}
      {...rest}
    >
      <div className="flex flex-col items-center justify-center gap-3">
        <IconInfo className="size-6 fill-neutral-500" />

        <div className="text-center text-xs font-semibold text-neutral-500">
          {finalI18n.message}
        </div>
      </div>

      {onRetry ? (
        <div className="flex items-center">
          <ButtonCTA
            type="button"
            variant={ButtonCTAVariant.DARK_GRAY_BRAND_OUTLINE}
            size={ButtonCTASize.SMALL}
            iconLeft={<IconRefresh />}
            onClick={onRetry}
            aria-label={finalI18n.retry}
          >
            {finalI18n.retry}
          </ButtonCTA>
        </div>
      ) : null}
    </div>
  );
};

export default memo(ErrorStateCard);
